module.exports = __webpack_public_path__ + "img/ls.8897de2a.svg";